export default "__VITE_ASSET__DMUsSCaJ__"